<template>
  <div class="app">
    <router-view v-slot="{ Component }">
      <component :is="Component"></component>
    </router-view>
  </div>
</template>

<style lang="less">
  .app{
    height: 100%;
  }
  :root {
            --sidebar-width: 200px;
            --sidebar-collapsed-width: 64px;
            --header-height: 60px;
            --tabs-height: 56px;
            --breadcrumb-height: 50px;
        }
</style>
